import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface StartPhoneVerificationForCandidateResponse
  extends BackendResponse {}

export const startPhoneVerificationForCandidate =
  withNextApi<StartPhoneVerificationForCandidateResponse>(
    "/cvp/CvpStartPhoneVerification"
  );
